/**
 * Notification Sound Utility
 * Fix 56 (Feb 2026) — Sound playback DISABLED globally per user choice
 * (semua notif via Telegram). Kode utility dipertahankan supaya callers
 * di 3 bell components (Marketing/Gudang/Nakes) tidak perlu diubah;
 * `playNotificationSound()` sekarang no-op yang selalu return false.
 * Toggle setting (`isNotificationSoundEnabled`, `setNotificationSoundEnabled`)
 * tetap ada supaya UI setting tidak crash.
 */

const STORAGE_KEY = 'notif_sound_enabled';

export function isNotificationSoundEnabled() {
  // Fix 56 — Selalu return false. UI toggle di bell dropdown akan
  // konsisten menampilkan "off".
  return false;
}

export function setNotificationSoundEnabled(enabled) {
  // Fix 56 — Persist preference tapi tidak ada efek (playNotificationSound
  // no-op). Dipertahankan supaya tombol toggle di bell tidak error.
  try {
    localStorage.setItem(STORAGE_KEY, enabled ? 'true' : 'false');
  } catch (_) {
    // ignore
  }
}

/**
 * Fix 56 — Global disable: sound notif in-app dimatikan (user pakai Telegram
 * saja). Function dipertahankan supaya caller di 3 bell components tidak
 * perlu diubah. Selalu return false.
 */
export function playNotificationSound() {
  return false;
}
